import React, {Component} from 'react';
import {Link} from 'react-router';
import Translate from '../layout/Translate';

export default class Day extends Component {


    componentWillMount() {



    }


    componentWillUpdate() {



    }



    openHotelPhoto(photo){

        console.log(photo)
        photo.single = true;
        this.props.actions.selectMapPhoto(photo, 0, true);

    }


    openDayPhoto(photo){
        photo.single = true;
        var photoObject = Object.assign({thumbnails: []}, photo);
        if (photo.previews) {
            for (var key in photo.previews) {
                photoObject.thumbnails[key] = {
                    url: photo.previews[key]
                };
            }
        }


        console.log(photoObject)
        this.props.actions.selectMapPhoto(photoObject, 0);

    }



    selectLandmark(landmark) {
        this.props.actions.selectLandmark(landmark);
    }


    render() {
        let { day } = this.props;

        day.note = {};
        day.programServices.forEach(function (service) {
            if (service.config.active && service.config.distance) {
                day.hasNote = true;
                if (day.note[service.type]) {
                    day.note[service.type].distance += parseFloat(service.config.distance);
                    day.note[service.type].duration += parseFloat(service.config.duration);
                } else {
                    day.note[service.type] = {
                        distance: parseFloat(service.config.distance),
                        duration: parseFloat(service.config.duration),
                        title: service.typeTitle
                    }
                }
            }
        });
        
        return (

            <div className={"day " + (!this.props.mobile && this.props.active?"day_active ":"") + (this.props.mobile && day.active?"day_active ":"") + (this.props.mobile?"day_mobile ":"")}>
                <ul className="day__list">
                    {day.programServices.sort(function (a, b) {
                        if (a.time > b.time) {
                            return 1;
                        }
                        if (a.time < b.time) {
                            return -1;
                        }
                        return 0;
                    }).map((service, i) =>
                        <li className="day__activity"
                            key={i}>
                            {service.config.active &&
                            <div>

                                <div className="day__time">

                                    {service.type != 'overnight' &&
                                    <span>
                                      {service.config.hours < 10 &&
                                      <span>0</span>}
                                        {service.config.hours}
                                        <span>:</span>
                                        {service.config.minutes < 10 &&
                                        <span>0</span>}
                                        {service.config.minutes}
                                    </span>
                                    }
                                </div>
                                <div
                                    className="day__description">
                                    <div
                                        className="day__type">
                                        {service.title} {!!service.is_option &&
                                    <span> <span className="day__optional"> &mdash; <Translate slug="tour__day__optional"/></span></span>}
                                    </div>
                                    <div
                                        className="day__text">
                                        {service.description}

                                    </div>
                                </div>
                            </div>
                            }
                        </li>
                    )}
                </ul>

                <div className="day__sidebar">
                    {day.images && day.images.previews && day.images.previews.browsing1000 &&
                        <div className="day__info">
                            <div className="day__subtitle"><Translate slug="tour__day__photo" /></div>
                            <div className="day__photo"  onClick={this.openDayPhoto.bind(this, day.images)}>
                                <img className="" src={day.images.previews.browsing1000} alt={(day.images.image)?day.images.image.title:''} />
                            </div>
                        </div>
                    }
                    {(day.end || day.start) &&
                        <div className="day__info">
                            <div className="day__subtitle">
                                <Translate slug="tour__day__locations"/>
                            </div>
                            <div className="day__location">
                                {day.start}
                                {(day.end && (day.end != day.start) && day.start) &&
                                <span>
                                &nbsp;&mdash;&nbsp;
                            </span>
                                }
                                {(day.end && (day.end != day.start)) &&
                                <span>
                             {day.end}
                            </span>
                                }
                            </div>
                        </div>
                    }

                    {day.programServices.map((service, i) =>
                     <div>
                        {service.type == 'overnight' && service.serviceItem  && service.config.active &&
                            <div className="day__info">
                                <div className="day__subtitle"><Translate slug="day__accommodation" /></div>

                                <div className="hotel">
                                    {service.serviceItem && service.serviceItem.gallery && service.serviceItem.gallery.length &&
                                    <div onClick={this.openHotelPhoto.bind(this, service.serviceItem.gallery[0])}
                                         className="hotel__title"><span>{service.serviceItem.title}</span></div>
                                    }
                                    {(!service.serviceItem.gallery || !service.serviceItem.gallery.length) &&
                                    <div className="hotel__title hotel__title_without_photo">
                                        <span>{service.serviceItem.title}</span></div>
                                    }


                                    <div className="hotel__subtitle">
                                        {service.serviceSubitem && service.serviceSubitem.title &&
                                        <div className="hotel__description">
                                            {service.serviceSubitem.title}
                                        </div>
                                        }
                                    </div>
                                </div>


                            </div>
                        }
                    </div>
                    )}




                    {(day.landmarks && !!day.landmarks.length) &&

                        <div className="day__info">
                            <div className="day__subtitle"><span> <Translate slug="tour__day__landmarks"/></span></div>
                            <ul className="day_landmarks">
                                {day.landmarks.map((landmark, i)=>
                                    <li className="day__landmark">
                                        <Link to={"/info/landmarks/" + landmark.slug}
                                              onClick={this.selectLandmark.bind(this, landmark)}>{landmark.title}</Link>
                                    </li>
                                )}
                            </ul>

                        </div>

                    }




                    {day.hasNote &&
                    <div className="day__info">
                        <div className="day__subtitle">
                            <Translate slug="tour__day__note"/>
                        </div>
                        {Object.keys(day.note).map((key) =>
                            <p className="day__note">
                                {!!day.note[key].duration &&
                                <span>{day.note[key].duration} <Translate slug="tour__hour"/> </span>
                                }
                            <span
                                className={((!day.note[key].duration)?'day__info_capitalize':'')}>
                                {(day.note[key].title)?day.note[key].title.toLowerCase():day.note[key].title}
                            </span>
                                {!!day.note[key].distance &&
                                <span>
                                &nbsp;
                                    ({day.note[key].distance}
                                    <Translate slug="tour__km"/>)</span>
                                }
                            </p>
                        )}
                    </div>
                    }





                </div>






            </div>


        );
    }
}



// WEBPACK FOOTER //
// ./src/common/components/tour/Day.js